import React from "react";
import { UseFieldConfig } from "react-final-form";

import RadixSelect, { RadixSelectProps } from "./RadixSelect";

type Props = RadixSelectProps & UseFieldConfig<string>;

const SelectField: React.FC<Props> = (props) => <RadixSelect {...props} />;

export default SelectField;
